import { render } from "./RadioButtonGroup.vue?vue&type=template&id=9b8ad98c&scoped=true&ts=true"
import script from "./RadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./RadioButtonGroup.vue?vue&type=script&lang=ts"

import "./RadioButtonGroup.vue?vue&type=style&index=0&id=9b8ad98c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b8ad98c"]])

export default __exports__